// extracted by mini-css-extract-plugin
module.exports = {"container":"OverlayDrawer_container__1Gtmd","backdrop":"OverlayDrawer_backdrop__30enm","drawer":"OverlayDrawer_drawer__1NHT2"};